/*
 * @Author: yidan.chen
 * @Date: 2025-02-10 15:55:32
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-03-10 11:29:44
 */
import { commonServerInstance, downloadInstance } from '@/utilities/instances'

export interface IBEFList {
  partner_id: string
  invoice_number: string
  start_date: string
  end_date: string
  billing_status: string // Select from fetchQuarantineOrderStatus
  per_page: string
  page: string
}

export const fetchBEFList = async (query: IBEFList) => {
  const response = await commonServerInstance.get('/settle/bill', {
    params: query
  })
  return response?.data?.data
}

export const downloadBEFList = async (
  params: Partial<IBEFList> & { ids: string }
) => {
  try {
    const response = await downloadInstance.get('/settle/bill/download-list', {
      params
    })
    const contentDisposition = response.headers['content-disposition']
    let filename = 'bill_list.xlsx'

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+?)"|filename=(.+)/)
      if (match) {
        filename = match[1] || match[2]
      }
    }
    const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = fileUrl
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(fileUrl)
    document.body.removeChild(link)

    return fileUrl
  } catch (error) {
    throw error
  }
}

export const asyncDownloadBEFInvoice = async (
  params: Partial<IBEFList> & { ids: string }
) => {
  const response = await commonServerInstance.get(
    '/settle/bill/download-invoices',
    { params }
  )
  return response?.data?.data
}

export const asyncDownloadBEFDetail = async (
  params: Partial<IBEFList> & { ids: string }
) => {
  const response = await commonServerInstance.get(
    '/settle/bill/download-bill-details',
    { params }
  )
  return response?.data?.data
}

export const batchReviewBills = async (
  params: Partial<IBEFList> & { ids: string; action: 'approve' | 'reject' }
) => {
  const response = await commonServerInstance.post(
    '/settle/bill/batch-review',
    params
  )
  return response
}

/**
 * Recent billing periods for one partner. Each period carries
 * `split_by_customer_in_effect` (0/1), the split value in force at its start.
 */
export const fetchBillingPeriodByPartnerId = async (params: {
  partner_id: string
}) => {
  const response = await commonServerInstance.get(
    '/settle/bill/recent-bill-periods',
    { params }
  )
  return response?.data?.data
}

export const createBEF = async (params: {
  partner_id: string
  period_from: string
  period_to: string
  billing_type: 'invoice' | 'credit-note'
  /**
   * The sub-account the BEF is split to: sent exactly when the period's split
   * is in effect, absent for a Parent Merchant BEF. The server refuses either
   * mismatch with the reason. Validated as `nullable|integer`, which accepts
   * the numeric string the dialog's option values carry.
   */
  customer_id?: string
}) => {
  const response = await commonServerInstance.post(
    '/settle/bill/create-new',
    params
  )
  return response
}
